import { Spinner } from "design-react-kit";

const SmallSpinner = () => (
  <div className="me-2 small-spinner">
    <Spinner active />
  </div>
);

export default SmallSpinner;
